export const en = {
    "additional": "Additional",
    "additional-link": "Link to form",
    "button-off": "Turn off",
    "button-save": "Save",
    "description-sum": "Enter the default amount that you want to show as a hint for users. Remember that\nthe maximum size of the balance in the UMoney wallet is {' '}\n[limited]: if the wallet is full,\nusers will not be able to transfer anything to you.",
    "description-wallet": "Enter your wallet number. Its [status] must be named or identified. If you have an anonymous status, you will not be able to receive a transfer. If you don't have one yet a wallet on UMoney, you can create it [here].",
    "error-no-published": "The donation form settings are only available for published dialogs",
    "form-settings": "Form settings",
    "label-sum": "Hint amount",
    "label-wallet": "UMoney wallet",
    "page-header-description": "Create a form for donations so that users can support you. It will appear in the catalog\non the page of your skill.",
    "page-header-title": "Donations",
    "stub-text": "Section unavailable",
    "stub-text-has-donat": "The section will become available after specifying the wallet number",
    "stub-text-hide-store": "This section is only available for public skills",
    "sum-validate-is-number": "The sum must be a number",
    "sum-validate-no-more-15k": "maximum of 15000",
    "wallet-validate-number": "Invalid wallet number"
} as const;
export const ru = {
    "additional": "Дополнительно",
    "additional-link": "Ссылка на форму",
    "button-off": "Отключить",
    "button-save": "Сохранить",
    "description-sum": "Укажите сумму по умолчанию, которую нужно показывать как подсказку для пользователей. Помните, что\n        максимальный размер баланса в кошельке ЮMoney{' '}\n        [ограничен]: если кошелек заполнен,\n        пользователи не смогут вам ничего перечислить.",
    "description-wallet": "Укажите номер своего кошелька. Его [статус] должен быть именным или\n        идентифицированным. При анонимном статусе вы не сможете получить перевод. Если у вас ещё нет\n        кошелька на ЮMoney, его можно создать [здесь].",
    "error-no-published": "Настройки формы донатов доступны только для опубликованных диалогов",
    "form-settings": "Настройки формы",
    "label-sum": "Сумма для подсказки",
    "label-wallet": "Кошелёк ЮMoney",
    "page-header-description": "Создайте форму для донатов, чтобы пользователи могли вас поддержать. Она появится в каталоге\n                на странице вашего навыка.",
    "page-header-title": "Донаты",
    "stub-text": "Раздел недоступен",
    "stub-text-has-donat": "Раздел станет доступен после указания номера кошелька",
    "stub-text-hide-store": "Раздел доступен только для публичных навыков",
    "sum-validate-is-number": "Сумма должна быть числом",
    "sum-validate-no-more-15k": "Максимум 15000",
    "wallet-validate-number": "Некорректный номер кошелька"
} as const;